export enum LeaveSubsidyProvider {
EFKA,
DYPA,
}
